module.exports = __webpack_public_path__ + "static/img/Instagram.4a242559.png";